declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    insideLinks: {
      /**
       * Add an image
       */

      insertInsideLinks: ({
        thumbnail,
        title,
        id,
        type,
        url,
      }: {
        thumbnail?: string
        title?: string
        id?: string
        type?: string
        url?: string
      }) => ReturnType
    }
  }
}

import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import InsideLinksComponent from './InsideLinksComponent.js'

export const InsideLinks = Node.create({
  name: 'insideLinks',

  group: 'block',
  content: 'inline*',
  draggable: true,

  // content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'div[data-type="social-media-embed"]',
      },
    ]
  },

  addAttributes() {
    return {
      id: {
        default: null,
      },
      url: {
        default: null,
      },
      title: {
        default: '',
      },
      thumbnail: {
        default: '',
      },
      draggable: {
        default: true,
      },
      type: { default: null },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => {
        return this.editor
          .chain()
          .insertContentAt(this.editor.state.selection.head, {
            type: this.type.name,
          })
          .focus()
          .run()
      },
    }
  },

  // renderHTML({ HTMLAttributes }) {
  //   return [
  //     "div",
  //     mergeAttributes(HTMLAttributes, { "data-type": "insideLinks" }),
  //     0,
  //   ];
  // },
  // parseHTML() {
  //   return [
  //     {
  //       tag: 'div[data-type="social-media-embed"]',
  //     },
  //   ];
  // },

  renderHTML({ node, HTMLAttributes }) {
    const { id, url, title, thumbnail, draggable } = node.attrs

    if (!id) {
      return [
        'div',
        mergeAttributes(HTMLAttributes, {
          'data-type': 'social-media-embed',
          class: 'socialMediaContainer',
        }),
        [
          'div',
          {
            class:
              'w-full bg-zinc-100 py-8 px-6 flex items-center justify-center gap-2 socialMediaCard',
            draggable: draggable ? 'true' : 'false',
            'data-drag-handle': '',
          },
          [
            'svg',
            {
              class: 'h-6 w-6',
              // SVG content for ExternalLinkIcon
            },
          ],
          [
            'p',
            {
              class: 'w-full flex items-center justify-start mt-0',
              style: 'margin-top: 0;',
            },
            'Add Internal Content Links',
          ],
        ],
      ]
    }

    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'social-media-embed',
        class: 'socialMediaContainer',
      }),
      [
        'div',
        {
          class: 'flex justify-center items-center w-full gap-x-6',
        },
        [
          'div',
          {
            class: 'flex justify-center items-center',
          },
          [
            'div',
            {
              class: 'w-[32px] h-[64px] bg-blue-400',
            },
          ],
          [
            'img',
            {
              src: thumbnail,
              width: '212',
              height: '120',
              alt: '',
              class: '-ml-6 !w-[212px] !h-[120px] object-cover',
            },
          ],
        ],
        [
          'div',
          {
            class: 'flex flex-col justify-start items-start font-trt gap-y-2',
          },
          [
            'a',
            {
              class: 'text-black dark:text-white text-lg capitalize w-full',
              href: url,
              dir: 'ltr', // Adjust based on your i18n setup
            },
            'Read More', // Adjust based on your i18n setup
          ],
          [
            'h3',
            {
              class: 'text-2xl font-bold !mt-0 w-full',
              dir: 'ltr', // Adjust based on your i18n setup
            },
            title,
          ],
        ],
      ],
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(InsideLinksComponent)
  },

  addCommands() {
    return {
      insertInsideLinks:
        ({
          thumbnail,
          title,
          id,
          type,
          url,
        }: {
          thumbnail?: string
          title?: string
          id?: string
          type?: string
          url?: string
        }) =>
        ({ commands, state }) => {
          return commands.insertContent({
            type: 'insideLinks',
            attrs: {
              thumbnail,
              title,
              id,
              type,
              url,
            },
          })
        },
    }
  },
})

function isValidHttpUrl(string: string) {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}
